<template>
    <el-dialog title="修改密码-对话框" width="640px" :model-value="modelValue" @close="closed" :close-on-click-modal="false">
        <el-form ref="formRef" :model="formData" :rules="formRules" label-width="120px" style="max-width: 540px">
            <el-form-item label="原密码" prop="password">
                <el-input v-model="formData.password" type="password"></el-input>
            </el-form-item>
            <el-form-item label="新密码" prop="newPassword">
                <el-input v-model="formData.newPassword" type="password"></el-input>
            </el-form-item>
            <el-form-item label="确认新密码" prop="reNewPassword">
                <el-input v-model="formData.reNewPassword" type="password"></el-input>
            </el-form-item>
        </el-form>

        <template #footer>
            <span class="dialog-footer">
                <el-button @click="closed">取消</el-button>
                <el-button type="primary" :loading="submitLoading" @click="onConfirm">确定</el-button>
            </span>
        </template>
    </el-dialog>
</template>
<script setup>
import { defineEmits, defineProps, ref } from 'vue'
import { ElMessage } from 'element-plus'
import { updatePassword } from '@/api/sys'

defineProps({
    modelValue: {
        type: Boolean,
        required: true
    }
})
const emits = defineEmits(['update:modelValue', 'updateForm'])

// 表单源
const formData = ref({
    password: '',
    newPassword: '',
    reNewPassword: ''
})
// 验证规则
const validatePass = () => {
    return (rule, value, callback) => {
        if (value.length < 6) {
            callback(new Error('请输入新密码且不少于6位'))
        } else {
            if (formData.value.reNewPassword !== '') {
                if (!formRef.value) return
                formRef.value.validateField('reNewPassword', () => null)
            }
            callback()
        }
    }
}

const validatePass2 = () => {
    return (rule, value, callback) => {
        if (value.length < 6) {
            callback(new Error('请输入确认新密码且不少于6位'))
        } else if (value !== formData.value.newPassword) {
            callback(new Error('新密码与确认新密码不相等！'))
        } else {
            callback()
        }
    }
}
const formRules = ref({
    password: [
        {
            required: true,
            trigger: 'blur',
            message: '请输入原始密码且不少于6位'
        },
        {
            min: 6,
            max: 20,
            message: '输入长度为6-20字',
            trigger: 'blur'
        }
    ],
    newPassword: [
        {
            required: true,
            trigger: 'blur',
            validator: validatePass()
        }
    ],
    reNewPassword: [
        {
            required: true,
            trigger: 'blur',
            validator: validatePass2()
        }
    ]
})

const submitLoading = ref(false)
const formRef = ref(null)
// 关闭
const closed = () => {
    emits('update:modelValue', false)
    formRef.value.resetFields()
}

// 确定按钮点击事件
const onConfirm = async () => {
    // 进行表单校验
    formRef.value.validate(async (valid) => {
        if (!valid) return
        submitLoading.value = true
        const err = await updatePassword(formData.value).catch((err) => {
            submitLoading.value = false
            return err
        })
        if (err) return
        // 修改成功
        emits('updateForm')
        ElMessage.success('密码修改成功，请重新登录！')
        submitLoading.value = false
        closed()
    })
}
</script>

<style lang="scss" scoped></style>
